// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               unknown
// source: bracket/payload/BracketPayloadPt.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { ApiResultPayload } from "../../common/model/ApiResultCodePt";
import { WeightClassPayload } from "../../fight/model/FightPt";
import {
  AgeDivisionPayload,
  ageDivisionPayloadFromJSON,
  ageDivisionPayloadToJSON,
} from "../../fight/model/enums/AgeDivisionPt";
import {
  FightSportPayload,
  fightSportPayloadFromJSON,
  fightSportPayloadToJSON,
} from "../../fight/model/enums/FightSportPt";
import { GenderPayload, genderPayloadFromJSON, genderPayloadToJSON } from "../../fight/model/enums/GenderPt";
import {
  BracketMatchPlayerPayload,
  BracketMatchStatusPayload,
  bracketMatchStatusPayloadFromJSON,
  bracketMatchStatusPayloadToJSON,
  BracketPayload,
  BracketSizePayload,
  bracketSizePayloadFromJSON,
  bracketSizePayloadToJSON,
  BracketSummaryPayload,
} from "../model/BracketPt";

export const protobufPackage = "io.teamsillim.fightbracket.idl.bracket.payload";

export interface BracketGetByTournamentRequestPayload {
  /** 대회 고유 id */
  tournamentId: string;
}

export interface BracketGetByTournamentResponsePayload {
  /** 결과 */
  result:
    | ApiResultPayload
    | undefined;
  /** 확정된 대진표 목록 (종목 · 부 · 체급 순) */
  data: BracketSummaryPayload[];
}

/** 대회 전체 대진표 (모든 체급의 경기 트리를 한 번에) */
export interface BracketGetAllByTournamentRequestPayload {
  /** 대회 고유 id */
  tournamentId: string;
}

export interface BracketGetAllByTournamentResponsePayload {
  /** 결과 */
  result:
    | ApiResultPayload
    | undefined;
  /** 체급 오름차순 대진표 목록 (각 대진표에 경기 목록이 담긴다) */
  data: BracketPayload[];
}

export interface BracketGetByIdRequestPayload {
  /** 대진표 고유 id */
  id: string;
}

export interface BracketGetByIdResponsePayload {
  /** 결과 */
  result:
    | ApiResultPayload
    | undefined;
  /** 응답 (경기 목록 포함) */
  data: BracketPayload | undefined;
}

/** 편성 대상 체급 목록 (관리자 대진 편성 화면) */
export interface BracketGetDrawTargetRequestPayload {
  /** 대회 고유 id */
  tournamentId: string;
}

export interface BracketGetDrawTargetResponsePayload {
  /** 결과 */
  result:
    | ApiResultPayload
    | undefined;
  /** 편성 대상 (승인 완료 + 체급 확정 선수를 체급별로 묶은 것) */
  data: BracketDrawTargetPayload[];
}

/** 편성 대상 한 줄 */
export interface BracketDrawTargetPayload {
  /** 종목 */
  sport: FightSportPayload;
  /** 부 */
  division: AgeDivisionPayload;
  /** 성별 */
  gender: GenderPayload;
  /** 체급 */
  weightClass:
    | WeightClassPayload
    | undefined;
  /** 편성 대상 선수 수 */
  playerCount: number;
  /** 이미 편성된 대진표 id (없으면 빈 문자열) */
  bracketId: string;
  /** 편성된 대진표가 공개돼 있는가 (미편성이면 false) */
  isPublic: boolean;
}

/**
 * 대진 편성
 *
 * 이미 편성된 체급을 다시 편성하려면 isRedraw 를 켠다 — 기존 대진이 사라지고 확정도 풀린다.
 */
export interface BracketDrawRequestPayload {
  /** 대회 고유 id */
  tournamentId: string;
  /** 종목 */
  sport: FightSportPayload;
  /** 부 */
  division: AgeDivisionPayload;
  /** 성별 */
  gender: GenderPayload;
  /** 체급 */
  weightClass:
    | WeightClassPayload
    | undefined;
  /** 편성 규모 (AUTO 면 인원에 맞춰 자동 결정) */
  size: BracketSizePayload;
  /** 재편성 여부 */
  isRedraw: boolean;
}

export interface BracketDrawResponsePayload {
  /** 결과 */
  result:
    | ApiResultPayload
    | undefined;
  /** 편성된 대진표 (경기 목록 포함) */
  data: BracketPayload | undefined;
}

/**
 * 대회 전체 편성 — 편성 대상 체급을 고른 규모로 한 번에 뽑는다
 *
 * 이미 편성된 체급은 건너뛴다. isRedraw 를 켜면 그 체급까지 다시 뽑는다(기존 대진이 사라진다).
 * 체급 하나가 실패해도 나머지는 편성한다 — 실패한 체급을 사유와 함께 내려준다.
 */
export interface BracketDrawAllRequestPayload {
  /** 대회 고유 id */
  tournamentId: string;
  /** 편성 규모 (AUTO 면 체급마다 인원에 맞춰 정한다) */
  size: BracketSizePayload;
  /** 이미 편성된 체급도 다시 뽑을 것인가 (끄면 건너뛴다) */
  isRedraw: boolean;
}

export interface BracketDrawAllResponsePayload {
  /** 결과 */
  result:
    | ApiResultPayload
    | undefined;
  /** 편성한 체급 수 */
  drawnCount: number;
  /** 이미 편성돼 있어 건너뛴 체급 수 (isRedraw 를 켜면 0) */
  skippedCount: number;
  /** 편성하지 못한 체급 (나머지는 편성됐다) */
  failure: BracketDrawFailurePayload[];
}

/** 편성하지 못한 체급 한 줄 */
export interface BracketDrawFailurePayload {
  /** 종목 */
  sport: FightSportPayload;
  /** 부 */
  division: AgeDivisionPayload;
  /** 성별 */
  gender: GenderPayload;
  /** 체급 */
  weightClass:
    | WeightClassPayload
    | undefined;
  /** 화면용 실패 사유 */
  reason: string;
}

/**
 * 대진표 공개 여부 전환 (관리자)
 *
 * 편성은 곧 공개가 아니다 — 이 토글로 공개 조회에 내보내거나 다시 내린다.
 * **대회 단위**다 — 대진표는 체급별로 조금씩 내보내는 것이 아니라 한 장으로 낸다.
 */
export interface BracketUpdateVisibilityRequestPayload {
  /** 공개할 것인가 */
  isPublic: boolean;
  /** 대회 고유 id (그 대회의 대진표 전체를 함께 전환한다) */
  tournamentId: string;
}

export interface BracketRemoveRequestPayload {
  /** 대진표 고유 id */
  id: string;
}

/** 대회 경기 순서 조회 (기존 종이 대진표 1페이지 「경기순서」와 같은 표) */
export interface BracketGetMatchOrderRequestPayload {
  /** 대회 고유 id */
  tournamentId: string;
}

export interface BracketGetMatchOrderResponsePayload {
  /** 결과 */
  result:
    | ApiResultPayload
    | undefined;
  /** 경기 순번 오름차순 */
  data: BracketMatchOrderPayload[];
}

/**
 * 경기 순서 한 줄
 *
 * 「1경기 -66kg 통합 MMA 중등부 8강 / 홍코너 vs 청코너」 한 줄에 필요한 값만 담는다.
 */
export interface BracketMatchOrderPayload {
  /** 대회 전체 경기 순번 */
  orderNo: number;
  /** 경기 고유 id */
  matchId: string;
  /** 대진표 고유 id (트리로 넘어갈 때 쓴다) */
  bracketId: string;
  /** 종목 */
  sport: FightSportPayload;
  /** 부 */
  division: AgeDivisionPayload;
  /** 성별 */
  gender: GenderPayload;
  /** 체급 */
  weightClass:
    | WeightClassPayload
    | undefined;
  /** 라운드 표시명 (예: "8강" · "준결승" · "결승") */
  roundName: string;
  /** 홍코너 (비어 있으면 상위 라운드의 미정 자리다) */
  homePlayer:
    | BracketMatchPlayerPayload
    | undefined;
  /** 청코너 (비어 있으면 부전승 또는 미정) */
  awayPlayer:
    | BracketMatchPlayerPayload
    | undefined;
  /** 경기 상태 (예정 · 부전승) */
  status: BracketMatchStatusPayload;
}

function createBaseBracketGetByTournamentRequestPayload(): BracketGetByTournamentRequestPayload {
  return { tournamentId: "" };
}

export const BracketGetByTournamentRequestPayload: MessageFns<BracketGetByTournamentRequestPayload> = {
  encode(message: BracketGetByTournamentRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tournamentId !== "") {
      writer.uint32(10).string(message.tournamentId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BracketGetByTournamentRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBracketGetByTournamentRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tournamentId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BracketGetByTournamentRequestPayload {
    return { tournamentId: isSet(object.tournamentId) ? globalThis.String(object.tournamentId) : "" };
  },

  toJSON(message: BracketGetByTournamentRequestPayload): unknown {
    const obj: any = {};
    if (message.tournamentId !== "") {
      obj.tournamentId = message.tournamentId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BracketGetByTournamentRequestPayload>, I>>(
    base?: I,
  ): BracketGetByTournamentRequestPayload {
    return BracketGetByTournamentRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BracketGetByTournamentRequestPayload>, I>>(
    object: I,
  ): BracketGetByTournamentRequestPayload {
    const message = createBaseBracketGetByTournamentRequestPayload();
    message.tournamentId = object.tournamentId ?? "";
    return message;
  },
};

function createBaseBracketGetByTournamentResponsePayload(): BracketGetByTournamentResponsePayload {
  return { result: undefined, data: [] };
}

export const BracketGetByTournamentResponsePayload: MessageFns<BracketGetByTournamentResponsePayload> = {
  encode(message: BracketGetByTournamentResponsePayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.result !== undefined) {
      ApiResultPayload.encode(message.result, writer.uint32(10).fork()).join();
    }
    for (const v of message.data) {
      BracketSummaryPayload.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BracketGetByTournamentResponsePayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBracketGetByTournamentResponsePayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.result = ApiResultPayload.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.data.push(BracketSummaryPayload.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BracketGetByTournamentResponsePayload {
    return {
      result: isSet(object.result) ? ApiResultPayload.fromJSON(object.result) : undefined,
      data: globalThis.Array.isArray(object?.data)
        ? object.data.map((e: any) => BracketSummaryPayload.fromJSON(e))
        : [],
    };
  },

  toJSON(message: BracketGetByTournamentResponsePayload): unknown {
    const obj: any = {};
    if (message.result !== undefined) {
      obj.result = ApiResultPayload.toJSON(message.result);
    }
    if (message.data?.length) {
      obj.data = message.data.map((e) => BracketSummaryPayload.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BracketGetByTournamentResponsePayload>, I>>(
    base?: I,
  ): BracketGetByTournamentResponsePayload {
    return BracketGetByTournamentResponsePayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BracketGetByTournamentResponsePayload>, I>>(
    object: I,
  ): BracketGetByTournamentResponsePayload {
    const message = createBaseBracketGetByTournamentResponsePayload();
    message.result = (object.result !== undefined && object.result !== null)
      ? ApiResultPayload.fromPartial(object.result)
      : undefined;
    message.data = object.data?.map((e) => BracketSummaryPayload.fromPartial(e)) || [];
    return message;
  },
};

function createBaseBracketGetAllByTournamentRequestPayload(): BracketGetAllByTournamentRequestPayload {
  return { tournamentId: "" };
}

export const BracketGetAllByTournamentRequestPayload: MessageFns<BracketGetAllByTournamentRequestPayload> = {
  encode(message: BracketGetAllByTournamentRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tournamentId !== "") {
      writer.uint32(10).string(message.tournamentId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BracketGetAllByTournamentRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBracketGetAllByTournamentRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tournamentId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BracketGetAllByTournamentRequestPayload {
    return { tournamentId: isSet(object.tournamentId) ? globalThis.String(object.tournamentId) : "" };
  },

  toJSON(message: BracketGetAllByTournamentRequestPayload): unknown {
    const obj: any = {};
    if (message.tournamentId !== "") {
      obj.tournamentId = message.tournamentId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BracketGetAllByTournamentRequestPayload>, I>>(
    base?: I,
  ): BracketGetAllByTournamentRequestPayload {
    return BracketGetAllByTournamentRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BracketGetAllByTournamentRequestPayload>, I>>(
    object: I,
  ): BracketGetAllByTournamentRequestPayload {
    const message = createBaseBracketGetAllByTournamentRequestPayload();
    message.tournamentId = object.tournamentId ?? "";
    return message;
  },
};

function createBaseBracketGetAllByTournamentResponsePayload(): BracketGetAllByTournamentResponsePayload {
  return { result: undefined, data: [] };
}

export const BracketGetAllByTournamentResponsePayload: MessageFns<BracketGetAllByTournamentResponsePayload> = {
  encode(message: BracketGetAllByTournamentResponsePayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.result !== undefined) {
      ApiResultPayload.encode(message.result, writer.uint32(10).fork()).join();
    }
    for (const v of message.data) {
      BracketPayload.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BracketGetAllByTournamentResponsePayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBracketGetAllByTournamentResponsePayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.result = ApiResultPayload.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.data.push(BracketPayload.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BracketGetAllByTournamentResponsePayload {
    return {
      result: isSet(object.result) ? ApiResultPayload.fromJSON(object.result) : undefined,
      data: globalThis.Array.isArray(object?.data) ? object.data.map((e: any) => BracketPayload.fromJSON(e)) : [],
    };
  },

  toJSON(message: BracketGetAllByTournamentResponsePayload): unknown {
    const obj: any = {};
    if (message.result !== undefined) {
      obj.result = ApiResultPayload.toJSON(message.result);
    }
    if (message.data?.length) {
      obj.data = message.data.map((e) => BracketPayload.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BracketGetAllByTournamentResponsePayload>, I>>(
    base?: I,
  ): BracketGetAllByTournamentResponsePayload {
    return BracketGetAllByTournamentResponsePayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BracketGetAllByTournamentResponsePayload>, I>>(
    object: I,
  ): BracketGetAllByTournamentResponsePayload {
    const message = createBaseBracketGetAllByTournamentResponsePayload();
    message.result = (object.result !== undefined && object.result !== null)
      ? ApiResultPayload.fromPartial(object.result)
      : undefined;
    message.data = object.data?.map((e) => BracketPayload.fromPartial(e)) || [];
    return message;
  },
};

function createBaseBracketGetByIdRequestPayload(): BracketGetByIdRequestPayload {
  return { id: "" };
}

export const BracketGetByIdRequestPayload: MessageFns<BracketGetByIdRequestPayload> = {
  encode(message: BracketGetByIdRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BracketGetByIdRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBracketGetByIdRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BracketGetByIdRequestPayload {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: BracketGetByIdRequestPayload): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BracketGetByIdRequestPayload>, I>>(base?: I): BracketGetByIdRequestPayload {
    return BracketGetByIdRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BracketGetByIdRequestPayload>, I>>(object: I): BracketGetByIdRequestPayload {
    const message = createBaseBracketGetByIdRequestPayload();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseBracketGetByIdResponsePayload(): BracketGetByIdResponsePayload {
  return { result: undefined, data: undefined };
}

export const BracketGetByIdResponsePayload: MessageFns<BracketGetByIdResponsePayload> = {
  encode(message: BracketGetByIdResponsePayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.result !== undefined) {
      ApiResultPayload.encode(message.result, writer.uint32(10).fork()).join();
    }
    if (message.data !== undefined) {
      BracketPayload.encode(message.data, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BracketGetByIdResponsePayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBracketGetByIdResponsePayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.result = ApiResultPayload.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.data = BracketPayload.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BracketGetByIdResponsePayload {
    return {
      result: isSet(object.result) ? ApiResultPayload.fromJSON(object.result) : undefined,
      data: isSet(object.data) ? BracketPayload.fromJSON(object.data) : undefined,
    };
  },

  toJSON(message: BracketGetByIdResponsePayload): unknown {
    const obj: any = {};
    if (message.result !== undefined) {
      obj.result = ApiResultPayload.toJSON(message.result);
    }
    if (message.data !== undefined) {
      obj.data = BracketPayload.toJSON(message.data);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BracketGetByIdResponsePayload>, I>>(base?: I): BracketGetByIdResponsePayload {
    return BracketGetByIdResponsePayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BracketGetByIdResponsePayload>, I>>(
    object: I,
  ): BracketGetByIdResponsePayload {
    const message = createBaseBracketGetByIdResponsePayload();
    message.result = (object.result !== undefined && object.result !== null)
      ? ApiResultPayload.fromPartial(object.result)
      : undefined;
    message.data = (object.data !== undefined && object.data !== null)
      ? BracketPayload.fromPartial(object.data)
      : undefined;
    return message;
  },
};

function createBaseBracketGetDrawTargetRequestPayload(): BracketGetDrawTargetRequestPayload {
  return { tournamentId: "" };
}

export const BracketGetDrawTargetRequestPayload: MessageFns<BracketGetDrawTargetRequestPayload> = {
  encode(message: BracketGetDrawTargetRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tournamentId !== "") {
      writer.uint32(10).string(message.tournamentId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BracketGetDrawTargetRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBracketGetDrawTargetRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tournamentId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BracketGetDrawTargetRequestPayload {
    return { tournamentId: isSet(object.tournamentId) ? globalThis.String(object.tournamentId) : "" };
  },

  toJSON(message: BracketGetDrawTargetRequestPayload): unknown {
    const obj: any = {};
    if (message.tournamentId !== "") {
      obj.tournamentId = message.tournamentId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BracketGetDrawTargetRequestPayload>, I>>(
    base?: I,
  ): BracketGetDrawTargetRequestPayload {
    return BracketGetDrawTargetRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BracketGetDrawTargetRequestPayload>, I>>(
    object: I,
  ): BracketGetDrawTargetRequestPayload {
    const message = createBaseBracketGetDrawTargetRequestPayload();
    message.tournamentId = object.tournamentId ?? "";
    return message;
  },
};

function createBaseBracketGetDrawTargetResponsePayload(): BracketGetDrawTargetResponsePayload {
  return { result: undefined, data: [] };
}

export const BracketGetDrawTargetResponsePayload: MessageFns<BracketGetDrawTargetResponsePayload> = {
  encode(message: BracketGetDrawTargetResponsePayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.result !== undefined) {
      ApiResultPayload.encode(message.result, writer.uint32(10).fork()).join();
    }
    for (const v of message.data) {
      BracketDrawTargetPayload.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BracketGetDrawTargetResponsePayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBracketGetDrawTargetResponsePayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.result = ApiResultPayload.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.data.push(BracketDrawTargetPayload.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BracketGetDrawTargetResponsePayload {
    return {
      result: isSet(object.result) ? ApiResultPayload.fromJSON(object.result) : undefined,
      data: globalThis.Array.isArray(object?.data)
        ? object.data.map((e: any) => BracketDrawTargetPayload.fromJSON(e))
        : [],
    };
  },

  toJSON(message: BracketGetDrawTargetResponsePayload): unknown {
    const obj: any = {};
    if (message.result !== undefined) {
      obj.result = ApiResultPayload.toJSON(message.result);
    }
    if (message.data?.length) {
      obj.data = message.data.map((e) => BracketDrawTargetPayload.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BracketGetDrawTargetResponsePayload>, I>>(
    base?: I,
  ): BracketGetDrawTargetResponsePayload {
    return BracketGetDrawTargetResponsePayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BracketGetDrawTargetResponsePayload>, I>>(
    object: I,
  ): BracketGetDrawTargetResponsePayload {
    const message = createBaseBracketGetDrawTargetResponsePayload();
    message.result = (object.result !== undefined && object.result !== null)
      ? ApiResultPayload.fromPartial(object.result)
      : undefined;
    message.data = object.data?.map((e) => BracketDrawTargetPayload.fromPartial(e)) || [];
    return message;
  },
};

function createBaseBracketDrawTargetPayload(): BracketDrawTargetPayload {
  return { sport: 0, division: 0, gender: 0, weightClass: undefined, playerCount: 0, bracketId: "", isPublic: false };
}

export const BracketDrawTargetPayload: MessageFns<BracketDrawTargetPayload> = {
  encode(message: BracketDrawTargetPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sport !== 0) {
      writer.uint32(8).int32(message.sport);
    }
    if (message.division !== 0) {
      writer.uint32(16).int32(message.division);
    }
    if (message.gender !== 0) {
      writer.uint32(24).int32(message.gender);
    }
    if (message.weightClass !== undefined) {
      WeightClassPayload.encode(message.weightClass, writer.uint32(34).fork()).join();
    }
    if (message.playerCount !== 0) {
      writer.uint32(40).int32(message.playerCount);
    }
    if (message.bracketId !== "") {
      writer.uint32(50).string(message.bracketId);
    }
    if (message.isPublic !== false) {
      writer.uint32(64).bool(message.isPublic);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BracketDrawTargetPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBracketDrawTargetPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.sport = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.division = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.gender = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.weightClass = WeightClassPayload.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.playerCount = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.bracketId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.isPublic = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BracketDrawTargetPayload {
    return {
      sport: isSet(object.sport) ? fightSportPayloadFromJSON(object.sport) : 0,
      division: isSet(object.division) ? ageDivisionPayloadFromJSON(object.division) : 0,
      gender: isSet(object.gender) ? genderPayloadFromJSON(object.gender) : 0,
      weightClass: isSet(object.weightClass) ? WeightClassPayload.fromJSON(object.weightClass) : undefined,
      playerCount: isSet(object.playerCount) ? globalThis.Number(object.playerCount) : 0,
      bracketId: isSet(object.bracketId) ? globalThis.String(object.bracketId) : "",
      isPublic: isSet(object.isPublic) ? globalThis.Boolean(object.isPublic) : false,
    };
  },

  toJSON(message: BracketDrawTargetPayload): unknown {
    const obj: any = {};
    if (message.sport !== 0) {
      obj.sport = fightSportPayloadToJSON(message.sport);
    }
    if (message.division !== 0) {
      obj.division = ageDivisionPayloadToJSON(message.division);
    }
    if (message.gender !== 0) {
      obj.gender = genderPayloadToJSON(message.gender);
    }
    if (message.weightClass !== undefined) {
      obj.weightClass = WeightClassPayload.toJSON(message.weightClass);
    }
    if (message.playerCount !== 0) {
      obj.playerCount = Math.round(message.playerCount);
    }
    if (message.bracketId !== "") {
      obj.bracketId = message.bracketId;
    }
    if (message.isPublic !== false) {
      obj.isPublic = message.isPublic;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BracketDrawTargetPayload>, I>>(base?: I): BracketDrawTargetPayload {
    return BracketDrawTargetPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BracketDrawTargetPayload>, I>>(object: I): BracketDrawTargetPayload {
    const message = createBaseBracketDrawTargetPayload();
    message.sport = object.sport ?? 0;
    message.division = object.division ?? 0;
    message.gender = object.gender ?? 0;
    message.weightClass = (object.weightClass !== undefined && object.weightClass !== null)
      ? WeightClassPayload.fromPartial(object.weightClass)
      : undefined;
    message.playerCount = object.playerCount ?? 0;
    message.bracketId = object.bracketId ?? "";
    message.isPublic = object.isPublic ?? false;
    return message;
  },
};

function createBaseBracketDrawRequestPayload(): BracketDrawRequestPayload {
  return { tournamentId: "", sport: 0, division: 0, gender: 0, weightClass: undefined, size: 0, isRedraw: false };
}

export const BracketDrawRequestPayload: MessageFns<BracketDrawRequestPayload> = {
  encode(message: BracketDrawRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tournamentId !== "") {
      writer.uint32(10).string(message.tournamentId);
    }
    if (message.sport !== 0) {
      writer.uint32(16).int32(message.sport);
    }
    if (message.division !== 0) {
      writer.uint32(24).int32(message.division);
    }
    if (message.gender !== 0) {
      writer.uint32(32).int32(message.gender);
    }
    if (message.weightClass !== undefined) {
      WeightClassPayload.encode(message.weightClass, writer.uint32(42).fork()).join();
    }
    if (message.size !== 0) {
      writer.uint32(48).int32(message.size);
    }
    if (message.isRedraw !== false) {
      writer.uint32(56).bool(message.isRedraw);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BracketDrawRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBracketDrawRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tournamentId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.sport = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.division = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.gender = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.weightClass = WeightClassPayload.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.size = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.isRedraw = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BracketDrawRequestPayload {
    return {
      tournamentId: isSet(object.tournamentId) ? globalThis.String(object.tournamentId) : "",
      sport: isSet(object.sport) ? fightSportPayloadFromJSON(object.sport) : 0,
      division: isSet(object.division) ? ageDivisionPayloadFromJSON(object.division) : 0,
      gender: isSet(object.gender) ? genderPayloadFromJSON(object.gender) : 0,
      weightClass: isSet(object.weightClass) ? WeightClassPayload.fromJSON(object.weightClass) : undefined,
      size: isSet(object.size) ? bracketSizePayloadFromJSON(object.size) : 0,
      isRedraw: isSet(object.isRedraw) ? globalThis.Boolean(object.isRedraw) : false,
    };
  },

  toJSON(message: BracketDrawRequestPayload): unknown {
    const obj: any = {};
    if (message.tournamentId !== "") {
      obj.tournamentId = message.tournamentId;
    }
    if (message.sport !== 0) {
      obj.sport = fightSportPayloadToJSON(message.sport);
    }
    if (message.division !== 0) {
      obj.division = ageDivisionPayloadToJSON(message.division);
    }
    if (message.gender !== 0) {
      obj.gender = genderPayloadToJSON(message.gender);
    }
    if (message.weightClass !== undefined) {
      obj.weightClass = WeightClassPayload.toJSON(message.weightClass);
    }
    if (message.size !== 0) {
      obj.size = bracketSizePayloadToJSON(message.size);
    }
    if (message.isRedraw !== false) {
      obj.isRedraw = message.isRedraw;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BracketDrawRequestPayload>, I>>(base?: I): BracketDrawRequestPayload {
    return BracketDrawRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BracketDrawRequestPayload>, I>>(object: I): BracketDrawRequestPayload {
    const message = createBaseBracketDrawRequestPayload();
    message.tournamentId = object.tournamentId ?? "";
    message.sport = object.sport ?? 0;
    message.division = object.division ?? 0;
    message.gender = object.gender ?? 0;
    message.weightClass = (object.weightClass !== undefined && object.weightClass !== null)
      ? WeightClassPayload.fromPartial(object.weightClass)
      : undefined;
    message.size = object.size ?? 0;
    message.isRedraw = object.isRedraw ?? false;
    return message;
  },
};

function createBaseBracketDrawResponsePayload(): BracketDrawResponsePayload {
  return { result: undefined, data: undefined };
}

export const BracketDrawResponsePayload: MessageFns<BracketDrawResponsePayload> = {
  encode(message: BracketDrawResponsePayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.result !== undefined) {
      ApiResultPayload.encode(message.result, writer.uint32(10).fork()).join();
    }
    if (message.data !== undefined) {
      BracketPayload.encode(message.data, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BracketDrawResponsePayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBracketDrawResponsePayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.result = ApiResultPayload.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.data = BracketPayload.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BracketDrawResponsePayload {
    return {
      result: isSet(object.result) ? ApiResultPayload.fromJSON(object.result) : undefined,
      data: isSet(object.data) ? BracketPayload.fromJSON(object.data) : undefined,
    };
  },

  toJSON(message: BracketDrawResponsePayload): unknown {
    const obj: any = {};
    if (message.result !== undefined) {
      obj.result = ApiResultPayload.toJSON(message.result);
    }
    if (message.data !== undefined) {
      obj.data = BracketPayload.toJSON(message.data);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BracketDrawResponsePayload>, I>>(base?: I): BracketDrawResponsePayload {
    return BracketDrawResponsePayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BracketDrawResponsePayload>, I>>(object: I): BracketDrawResponsePayload {
    const message = createBaseBracketDrawResponsePayload();
    message.result = (object.result !== undefined && object.result !== null)
      ? ApiResultPayload.fromPartial(object.result)
      : undefined;
    message.data = (object.data !== undefined && object.data !== null)
      ? BracketPayload.fromPartial(object.data)
      : undefined;
    return message;
  },
};

function createBaseBracketDrawAllRequestPayload(): BracketDrawAllRequestPayload {
  return { tournamentId: "", size: 0, isRedraw: false };
}

export const BracketDrawAllRequestPayload: MessageFns<BracketDrawAllRequestPayload> = {
  encode(message: BracketDrawAllRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tournamentId !== "") {
      writer.uint32(10).string(message.tournamentId);
    }
    if (message.size !== 0) {
      writer.uint32(16).int32(message.size);
    }
    if (message.isRedraw !== false) {
      writer.uint32(24).bool(message.isRedraw);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BracketDrawAllRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBracketDrawAllRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tournamentId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.size = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.isRedraw = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BracketDrawAllRequestPayload {
    return {
      tournamentId: isSet(object.tournamentId) ? globalThis.String(object.tournamentId) : "",
      size: isSet(object.size) ? bracketSizePayloadFromJSON(object.size) : 0,
      isRedraw: isSet(object.isRedraw) ? globalThis.Boolean(object.isRedraw) : false,
    };
  },

  toJSON(message: BracketDrawAllRequestPayload): unknown {
    const obj: any = {};
    if (message.tournamentId !== "") {
      obj.tournamentId = message.tournamentId;
    }
    if (message.size !== 0) {
      obj.size = bracketSizePayloadToJSON(message.size);
    }
    if (message.isRedraw !== false) {
      obj.isRedraw = message.isRedraw;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BracketDrawAllRequestPayload>, I>>(base?: I): BracketDrawAllRequestPayload {
    return BracketDrawAllRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BracketDrawAllRequestPayload>, I>>(object: I): BracketDrawAllRequestPayload {
    const message = createBaseBracketDrawAllRequestPayload();
    message.tournamentId = object.tournamentId ?? "";
    message.size = object.size ?? 0;
    message.isRedraw = object.isRedraw ?? false;
    return message;
  },
};

function createBaseBracketDrawAllResponsePayload(): BracketDrawAllResponsePayload {
  return { result: undefined, drawnCount: 0, skippedCount: 0, failure: [] };
}

export const BracketDrawAllResponsePayload: MessageFns<BracketDrawAllResponsePayload> = {
  encode(message: BracketDrawAllResponsePayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.result !== undefined) {
      ApiResultPayload.encode(message.result, writer.uint32(10).fork()).join();
    }
    if (message.drawnCount !== 0) {
      writer.uint32(16).int32(message.drawnCount);
    }
    if (message.skippedCount !== 0) {
      writer.uint32(24).int32(message.skippedCount);
    }
    for (const v of message.failure) {
      BracketDrawFailurePayload.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BracketDrawAllResponsePayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBracketDrawAllResponsePayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.result = ApiResultPayload.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.drawnCount = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.skippedCount = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.failure.push(BracketDrawFailurePayload.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BracketDrawAllResponsePayload {
    return {
      result: isSet(object.result) ? ApiResultPayload.fromJSON(object.result) : undefined,
      drawnCount: isSet(object.drawnCount) ? globalThis.Number(object.drawnCount) : 0,
      skippedCount: isSet(object.skippedCount) ? globalThis.Number(object.skippedCount) : 0,
      failure: globalThis.Array.isArray(object?.failure)
        ? object.failure.map((e: any) => BracketDrawFailurePayload.fromJSON(e))
        : [],
    };
  },

  toJSON(message: BracketDrawAllResponsePayload): unknown {
    const obj: any = {};
    if (message.result !== undefined) {
      obj.result = ApiResultPayload.toJSON(message.result);
    }
    if (message.drawnCount !== 0) {
      obj.drawnCount = Math.round(message.drawnCount);
    }
    if (message.skippedCount !== 0) {
      obj.skippedCount = Math.round(message.skippedCount);
    }
    if (message.failure?.length) {
      obj.failure = message.failure.map((e) => BracketDrawFailurePayload.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BracketDrawAllResponsePayload>, I>>(base?: I): BracketDrawAllResponsePayload {
    return BracketDrawAllResponsePayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BracketDrawAllResponsePayload>, I>>(
    object: I,
  ): BracketDrawAllResponsePayload {
    const message = createBaseBracketDrawAllResponsePayload();
    message.result = (object.result !== undefined && object.result !== null)
      ? ApiResultPayload.fromPartial(object.result)
      : undefined;
    message.drawnCount = object.drawnCount ?? 0;
    message.skippedCount = object.skippedCount ?? 0;
    message.failure = object.failure?.map((e) => BracketDrawFailurePayload.fromPartial(e)) || [];
    return message;
  },
};

function createBaseBracketDrawFailurePayload(): BracketDrawFailurePayload {
  return { sport: 0, division: 0, gender: 0, weightClass: undefined, reason: "" };
}

export const BracketDrawFailurePayload: MessageFns<BracketDrawFailurePayload> = {
  encode(message: BracketDrawFailurePayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sport !== 0) {
      writer.uint32(8).int32(message.sport);
    }
    if (message.division !== 0) {
      writer.uint32(16).int32(message.division);
    }
    if (message.gender !== 0) {
      writer.uint32(24).int32(message.gender);
    }
    if (message.weightClass !== undefined) {
      WeightClassPayload.encode(message.weightClass, writer.uint32(34).fork()).join();
    }
    if (message.reason !== "") {
      writer.uint32(42).string(message.reason);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BracketDrawFailurePayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBracketDrawFailurePayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.sport = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.division = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.gender = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.weightClass = WeightClassPayload.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.reason = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BracketDrawFailurePayload {
    return {
      sport: isSet(object.sport) ? fightSportPayloadFromJSON(object.sport) : 0,
      division: isSet(object.division) ? ageDivisionPayloadFromJSON(object.division) : 0,
      gender: isSet(object.gender) ? genderPayloadFromJSON(object.gender) : 0,
      weightClass: isSet(object.weightClass) ? WeightClassPayload.fromJSON(object.weightClass) : undefined,
      reason: isSet(object.reason) ? globalThis.String(object.reason) : "",
    };
  },

  toJSON(message: BracketDrawFailurePayload): unknown {
    const obj: any = {};
    if (message.sport !== 0) {
      obj.sport = fightSportPayloadToJSON(message.sport);
    }
    if (message.division !== 0) {
      obj.division = ageDivisionPayloadToJSON(message.division);
    }
    if (message.gender !== 0) {
      obj.gender = genderPayloadToJSON(message.gender);
    }
    if (message.weightClass !== undefined) {
      obj.weightClass = WeightClassPayload.toJSON(message.weightClass);
    }
    if (message.reason !== "") {
      obj.reason = message.reason;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BracketDrawFailurePayload>, I>>(base?: I): BracketDrawFailurePayload {
    return BracketDrawFailurePayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BracketDrawFailurePayload>, I>>(object: I): BracketDrawFailurePayload {
    const message = createBaseBracketDrawFailurePayload();
    message.sport = object.sport ?? 0;
    message.division = object.division ?? 0;
    message.gender = object.gender ?? 0;
    message.weightClass = (object.weightClass !== undefined && object.weightClass !== null)
      ? WeightClassPayload.fromPartial(object.weightClass)
      : undefined;
    message.reason = object.reason ?? "";
    return message;
  },
};

function createBaseBracketUpdateVisibilityRequestPayload(): BracketUpdateVisibilityRequestPayload {
  return { isPublic: false, tournamentId: "" };
}

export const BracketUpdateVisibilityRequestPayload: MessageFns<BracketUpdateVisibilityRequestPayload> = {
  encode(message: BracketUpdateVisibilityRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.isPublic !== false) {
      writer.uint32(16).bool(message.isPublic);
    }
    if (message.tournamentId !== "") {
      writer.uint32(26).string(message.tournamentId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BracketUpdateVisibilityRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBracketUpdateVisibilityRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.isPublic = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tournamentId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BracketUpdateVisibilityRequestPayload {
    return {
      isPublic: isSet(object.isPublic) ? globalThis.Boolean(object.isPublic) : false,
      tournamentId: isSet(object.tournamentId) ? globalThis.String(object.tournamentId) : "",
    };
  },

  toJSON(message: BracketUpdateVisibilityRequestPayload): unknown {
    const obj: any = {};
    if (message.isPublic !== false) {
      obj.isPublic = message.isPublic;
    }
    if (message.tournamentId !== "") {
      obj.tournamentId = message.tournamentId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BracketUpdateVisibilityRequestPayload>, I>>(
    base?: I,
  ): BracketUpdateVisibilityRequestPayload {
    return BracketUpdateVisibilityRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BracketUpdateVisibilityRequestPayload>, I>>(
    object: I,
  ): BracketUpdateVisibilityRequestPayload {
    const message = createBaseBracketUpdateVisibilityRequestPayload();
    message.isPublic = object.isPublic ?? false;
    message.tournamentId = object.tournamentId ?? "";
    return message;
  },
};

function createBaseBracketRemoveRequestPayload(): BracketRemoveRequestPayload {
  return { id: "" };
}

export const BracketRemoveRequestPayload: MessageFns<BracketRemoveRequestPayload> = {
  encode(message: BracketRemoveRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BracketRemoveRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBracketRemoveRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BracketRemoveRequestPayload {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: BracketRemoveRequestPayload): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BracketRemoveRequestPayload>, I>>(base?: I): BracketRemoveRequestPayload {
    return BracketRemoveRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BracketRemoveRequestPayload>, I>>(object: I): BracketRemoveRequestPayload {
    const message = createBaseBracketRemoveRequestPayload();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseBracketGetMatchOrderRequestPayload(): BracketGetMatchOrderRequestPayload {
  return { tournamentId: "" };
}

export const BracketGetMatchOrderRequestPayload: MessageFns<BracketGetMatchOrderRequestPayload> = {
  encode(message: BracketGetMatchOrderRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tournamentId !== "") {
      writer.uint32(10).string(message.tournamentId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BracketGetMatchOrderRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBracketGetMatchOrderRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tournamentId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BracketGetMatchOrderRequestPayload {
    return { tournamentId: isSet(object.tournamentId) ? globalThis.String(object.tournamentId) : "" };
  },

  toJSON(message: BracketGetMatchOrderRequestPayload): unknown {
    const obj: any = {};
    if (message.tournamentId !== "") {
      obj.tournamentId = message.tournamentId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BracketGetMatchOrderRequestPayload>, I>>(
    base?: I,
  ): BracketGetMatchOrderRequestPayload {
    return BracketGetMatchOrderRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BracketGetMatchOrderRequestPayload>, I>>(
    object: I,
  ): BracketGetMatchOrderRequestPayload {
    const message = createBaseBracketGetMatchOrderRequestPayload();
    message.tournamentId = object.tournamentId ?? "";
    return message;
  },
};

function createBaseBracketGetMatchOrderResponsePayload(): BracketGetMatchOrderResponsePayload {
  return { result: undefined, data: [] };
}

export const BracketGetMatchOrderResponsePayload: MessageFns<BracketGetMatchOrderResponsePayload> = {
  encode(message: BracketGetMatchOrderResponsePayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.result !== undefined) {
      ApiResultPayload.encode(message.result, writer.uint32(10).fork()).join();
    }
    for (const v of message.data) {
      BracketMatchOrderPayload.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BracketGetMatchOrderResponsePayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBracketGetMatchOrderResponsePayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.result = ApiResultPayload.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.data.push(BracketMatchOrderPayload.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BracketGetMatchOrderResponsePayload {
    return {
      result: isSet(object.result) ? ApiResultPayload.fromJSON(object.result) : undefined,
      data: globalThis.Array.isArray(object?.data)
        ? object.data.map((e: any) => BracketMatchOrderPayload.fromJSON(e))
        : [],
    };
  },

  toJSON(message: BracketGetMatchOrderResponsePayload): unknown {
    const obj: any = {};
    if (message.result !== undefined) {
      obj.result = ApiResultPayload.toJSON(message.result);
    }
    if (message.data?.length) {
      obj.data = message.data.map((e) => BracketMatchOrderPayload.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BracketGetMatchOrderResponsePayload>, I>>(
    base?: I,
  ): BracketGetMatchOrderResponsePayload {
    return BracketGetMatchOrderResponsePayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BracketGetMatchOrderResponsePayload>, I>>(
    object: I,
  ): BracketGetMatchOrderResponsePayload {
    const message = createBaseBracketGetMatchOrderResponsePayload();
    message.result = (object.result !== undefined && object.result !== null)
      ? ApiResultPayload.fromPartial(object.result)
      : undefined;
    message.data = object.data?.map((e) => BracketMatchOrderPayload.fromPartial(e)) || [];
    return message;
  },
};

function createBaseBracketMatchOrderPayload(): BracketMatchOrderPayload {
  return {
    orderNo: 0,
    matchId: "",
    bracketId: "",
    sport: 0,
    division: 0,
    gender: 0,
    weightClass: undefined,
    roundName: "",
    homePlayer: undefined,
    awayPlayer: undefined,
    status: 0,
  };
}

export const BracketMatchOrderPayload: MessageFns<BracketMatchOrderPayload> = {
  encode(message: BracketMatchOrderPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orderNo !== 0) {
      writer.uint32(8).int32(message.orderNo);
    }
    if (message.matchId !== "") {
      writer.uint32(18).string(message.matchId);
    }
    if (message.bracketId !== "") {
      writer.uint32(26).string(message.bracketId);
    }
    if (message.sport !== 0) {
      writer.uint32(32).int32(message.sport);
    }
    if (message.division !== 0) {
      writer.uint32(40).int32(message.division);
    }
    if (message.gender !== 0) {
      writer.uint32(48).int32(message.gender);
    }
    if (message.weightClass !== undefined) {
      WeightClassPayload.encode(message.weightClass, writer.uint32(58).fork()).join();
    }
    if (message.roundName !== "") {
      writer.uint32(66).string(message.roundName);
    }
    if (message.homePlayer !== undefined) {
      BracketMatchPlayerPayload.encode(message.homePlayer, writer.uint32(74).fork()).join();
    }
    if (message.awayPlayer !== undefined) {
      BracketMatchPlayerPayload.encode(message.awayPlayer, writer.uint32(82).fork()).join();
    }
    if (message.status !== 0) {
      writer.uint32(88).int32(message.status);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BracketMatchOrderPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBracketMatchOrderPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.orderNo = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.matchId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.bracketId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.sport = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.division = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.gender = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.weightClass = WeightClassPayload.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.roundName = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.homePlayer = BracketMatchPlayerPayload.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.awayPlayer = BracketMatchPlayerPayload.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BracketMatchOrderPayload {
    return {
      orderNo: isSet(object.orderNo) ? globalThis.Number(object.orderNo) : 0,
      matchId: isSet(object.matchId) ? globalThis.String(object.matchId) : "",
      bracketId: isSet(object.bracketId) ? globalThis.String(object.bracketId) : "",
      sport: isSet(object.sport) ? fightSportPayloadFromJSON(object.sport) : 0,
      division: isSet(object.division) ? ageDivisionPayloadFromJSON(object.division) : 0,
      gender: isSet(object.gender) ? genderPayloadFromJSON(object.gender) : 0,
      weightClass: isSet(object.weightClass) ? WeightClassPayload.fromJSON(object.weightClass) : undefined,
      roundName: isSet(object.roundName) ? globalThis.String(object.roundName) : "",
      homePlayer: isSet(object.homePlayer) ? BracketMatchPlayerPayload.fromJSON(object.homePlayer) : undefined,
      awayPlayer: isSet(object.awayPlayer) ? BracketMatchPlayerPayload.fromJSON(object.awayPlayer) : undefined,
      status: isSet(object.status) ? bracketMatchStatusPayloadFromJSON(object.status) : 0,
    };
  },

  toJSON(message: BracketMatchOrderPayload): unknown {
    const obj: any = {};
    if (message.orderNo !== 0) {
      obj.orderNo = Math.round(message.orderNo);
    }
    if (message.matchId !== "") {
      obj.matchId = message.matchId;
    }
    if (message.bracketId !== "") {
      obj.bracketId = message.bracketId;
    }
    if (message.sport !== 0) {
      obj.sport = fightSportPayloadToJSON(message.sport);
    }
    if (message.division !== 0) {
      obj.division = ageDivisionPayloadToJSON(message.division);
    }
    if (message.gender !== 0) {
      obj.gender = genderPayloadToJSON(message.gender);
    }
    if (message.weightClass !== undefined) {
      obj.weightClass = WeightClassPayload.toJSON(message.weightClass);
    }
    if (message.roundName !== "") {
      obj.roundName = message.roundName;
    }
    if (message.homePlayer !== undefined) {
      obj.homePlayer = BracketMatchPlayerPayload.toJSON(message.homePlayer);
    }
    if (message.awayPlayer !== undefined) {
      obj.awayPlayer = BracketMatchPlayerPayload.toJSON(message.awayPlayer);
    }
    if (message.status !== 0) {
      obj.status = bracketMatchStatusPayloadToJSON(message.status);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BracketMatchOrderPayload>, I>>(base?: I): BracketMatchOrderPayload {
    return BracketMatchOrderPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BracketMatchOrderPayload>, I>>(object: I): BracketMatchOrderPayload {
    const message = createBaseBracketMatchOrderPayload();
    message.orderNo = object.orderNo ?? 0;
    message.matchId = object.matchId ?? "";
    message.bracketId = object.bracketId ?? "";
    message.sport = object.sport ?? 0;
    message.division = object.division ?? 0;
    message.gender = object.gender ?? 0;
    message.weightClass = (object.weightClass !== undefined && object.weightClass !== null)
      ? WeightClassPayload.fromPartial(object.weightClass)
      : undefined;
    message.roundName = object.roundName ?? "";
    message.homePlayer = (object.homePlayer !== undefined && object.homePlayer !== null)
      ? BracketMatchPlayerPayload.fromPartial(object.homePlayer)
      : undefined;
    message.awayPlayer = (object.awayPlayer !== undefined && object.awayPlayer !== null)
      ? BracketMatchPlayerPayload.fromPartial(object.awayPlayer)
      : undefined;
    message.status = object.status ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
